import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { PageHero, Section, Container, Btn } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { SITE } from "@/lib/content";
import { track } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", phone: "", company: "", business_type: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const label = "t-caption font-mono uppercase tracking-wide text-[var(--muted)]";

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.email.trim() || !f.message.trim()) { toast.error("Please add your name, email and a message."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, f);
      track("contact_submitted");
      toast.success("Thank you. Prox will reply personally, usually within a business day.");
      setF({ name: "", email: "", company: "", business_type: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please email info@prox-au.com.");
    }
    setBusy(false);
  };

  return (
    <>
      <Seo title="Contact" canonical="/contact" description="Get in touch with Prox, a Melbourne commercial advisory for fashion and consumer product brands." />
      <PageHero
        eyebrow="Contact"
        crumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
        title="Tell us what you are trying to fix."
        lead="For most things, the free call is faster. For anything else, this reaches Prox directly."
      />
      <Section bg="bone">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-6">
                <label className="block"><span className={label}>Your name *</span><input className="field mt-2" value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="contact-name" /></label>
                <label className="block"><span className={label}>Email *</span><input type="email" className="field mt-2" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="contact-email" /></label>
                <label className="block"><span className={label}>Business name</span><input className="field mt-2" value={f.company} onChange={(e) => set("company", e.target.value)} data-testid="contact-company" /></label>
                <label className="block"><span className={label}>Phone (optional)</span><input type="tel" className="field mt-2" placeholder="+61…" value={f.phone} onChange={(e) => set("phone", e.target.value)} data-testid="contact-phone" autoComplete="tel" /></label>
                <label className="block"><span className={label}>Business type</span><input className="field mt-2" placeholder="e.g. DTC womenswear" value={f.business_type} onChange={(e) => set("business_type", e.target.value)} /></label>
              </div>
              <label className="block"><span className={label}>Message *</span><textarea rows={5} className="field mt-2 resize-none" value={f.message} onChange={(e) => set("message", e.target.value)} data-testid="contact-message" /></label>
              <Btn type="submit" variant="clay" data-testid="contact-submit">{busy ? "Sending\u2026" : "Send message"}</Btn>
            </form>
          </div>
          <div className="lg:col-span-5 lg:border-l lg:border-[var(--stone)] lg:pl-10">
            <Eyebrow>Direct</Eyebrow>
            <div className="space-y-6 t-body">
              <div><p className={label}>Email</p><a href={`mailto:${SITE.email}`} className="lnk mt-1 inline-block">{SITE.email}</a></div>
              <div><p className={label}>Based in</p><p className="mt-1">{SITE.location}</p></div>
              <div><p className={label}>LinkedIn</p><a href={SITE.linkedin} target="_blank" rel="noreferrer" className="lnk mt-1 inline-block">Rasika Khode</a></div>
              <div className="pt-2"><Btn to="/book" variant="outline">Book the free fit call</Btn></div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
